<template>
  <div class="grid grid-flow-row gap-4">
    <div class="max-w-md p-6 bg-white border border-gray-200 rounded-lg shadow">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900">
        Factura
      </h5>

      <form class="max-w-sm mx-auto">
        <div class="mb-5">
          <div class="form-group">
            <label for="descripcion">Descripción</label>
            <input type="text"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="descripcion" v-model="form.descripcion" required />
          </div>

          <div class="form-group">
            <label for="cliente" class="text-black">Cliente</label>
            <select
              class="form-select form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="cliente" v-model="form.clienteId">
              <option value="">Seleccionar cliente</option>
              <option v-for="cliente in clientes" :key="cliente.id" :value="cliente.id">
                {{ cliente.nombreApellido }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="tipo-vehiculo" class="text-black">Servicio</label>
            <select
              class="form-select form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="tipo-vehiculo" v-model="form.servicioId">
              <option value="">Seleccionar servicio</option>
              <option v-for="tipoVehiculo in tiposVehiculos" :key="tipoVehiculo.id" :value="tipoVehiculo.id">
                {{ tipoVehiculo.nombre }}
              </option>
            </select>
          </div>

          <div class="form-group" v-if="form.servicioId">
            <label for="plazasDisponibles">Plazas disponibles</label>
            <input
              type="number"
              id="plazasDisponibles"
              :value="plazasDisponibles ?? 0"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm bg-gray-100 focus:border-emerald-300 focus:ring focus:ring-blue-200"
              readonly
              disabled
            />
          </div>

          <div class="form-group">
            <label for="tipoServicio" class="text-black">Tipo Servicio</label>
            <select
              class="form-select mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="tipoServicio" v-model="form.tipoServicioId">
              <option value="" disabled>Selecciona un tipo de servicio</option>
              <option v-for="tipoServicio in tiposDeServicio" :value="tipoServicio.id" :key="tipoServicio.id">
                {{ tipoServicio.nombre }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="importe">Importe</label>
            <input type="number"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="importe" min="1" v-model="form.importe" required />
          </div>
          <div class="form-group">
            <label for="importe">Importe abonado</label>
            <input type="number"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="importe" min="1" v-model="form.importeAbonado" required />
          </div>

          <div class="form-group">
            <label for="plazas">Plazas</label>
            <input type="number"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="plazas"
              min="1"
              :max="plazasDisponibles || undefined"
              v-model.number="form.plazas"
              :disabled="!form.servicioId"
            />
            <p v-if="form.plazas && plazasDisponibles !== null && form.plazas > plazasDisponibles" class="text-red-600 text-sm mt-1">
              No podés cargar más de {{ plazasDisponibles }} plazas.
            </p>
          </div>

          <div class="form-group">
            <label for="metodo-pago" class="text-black">Método de pago</label>
            <select
              class="form-control form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="metodo-pago" v-model="form.metodoPago" required>
              <option value="">Seleccionar método de pago</option>
              <option value="efectivo">Efectivo</option>
              <option value="e-check">E-check</option>
              <option value="retenciones">Retenciones</option>
              <option value="tarjeta">Tarjeta</option>
              <option value="transferencia">Transferencia</option>
            </select>
          </div>

          <div class="form-group">
            <label for="codigoPresupuesto">Código presupuesto</label>
            <select
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="codigoPresupuesto" v-model="form.presupuestoId" @change="cargarPresupuesto">
              <option :value="null">Seleccionar presupuesto</option>
              <option v-for="presupuesto in presupuestos" :key="presupuesto.id" :value="presupuesto.id">
                {{ presupuesto.codigo }}
              </option>
            </select>
          </div>

          <div class="form-group" v-if="isAdmin">
            <label for="fecha">Fecha</label>
            <input type="date"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              id="fecha" v-model="form.fecha" required />
          </div>
        </div>

        <button type="submit" @click.prevent="submitForm"
          class="text-black bg-green-300 hover:bg-green-600 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center">
          Guardar
        </button>

        <router-link :to="isAdmin ? '/ventas' : '/caja'"
          class="ml-5 font-medium text-green-500 hover:underline">Cancelar</router-link>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import lavadoService from "../../composables/api/lavadoService.js";
import clienteService from "../../composables/api/clienteService.js";
import cajaService from "../../composables/api/cajaService.js";
import _servicioService from "../../composables/api/servicioService.js";
import tipoServicioService from "../../composables/api/tipoServicioService";
import presupuestoService from "../../composables/api/presupuestoService.js";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    
    // Estados reactivos
    const isAdmin = ref(false);
    const cajaAbierta = ref({});
    const tiposLavados = ref([]);
    const tiposVehiculos = ref([]);
    const isNegativeImport = ref(false);
    const clientes = ref([]);
    const tiposDeServicio = ref([]);
    const presupuestos = ref([]);

    // Disponibilidad (mostrada) y ocupadas (solo estado interno)
    const plazasDisponibles = ref(null);
    const cantidadOcupada = ref(0); // estado interno para consistencia

    const form = ref({
      id: 0,
      cajaId: route.query.idCaja || 0,
      codigoPresupuesto: "",
      presupuestoId: null,
      fecha: new Date().toISOString().split("T")[0],
      clienteId: "",
      servicioId: "",
      descripcion: "",
      importe: 0,
      responsable: "",
      metodoPago: "",
      tipoServicioId: "",
      tipoServicioNombre: "",
      importeAbonado: 0,
      importeOrigen: null,
      plazas: 0,
    });

    // Cargar servicio: precio, tipoServicioId y disponibilidad
    const obtenerTipoServicioYImporte = async (servicioId) => {
      try {
        const response = await _servicioService.getById(servicioId);
        if (response) {
          form.value.importe = Number(response.precio ?? 0);
          form.value.tipoServicioId = response.tipoServicioId;
          form.value.importeOrigen = 'servicio';

          // En tu modelo, maxCantidad ya representa DISPONIBLES
          plazasDisponibles.value = Number(response.maxCantidad ?? 0);

          // Normalizar ocupadas para cálculos futuros
          cantidadOcupada.value = Number(response.cantidadOcupada ?? 0);
        } else {
          plazasDisponibles.value = null;
          cantidadOcupada.value = 0;
        }
      } catch (error) {
        console.error("Error al obtener servicio:", error);
        plazasDisponibles.value = null;
        cantidadOcupada.value = 0;
      }
    };

    // Cargar presupuesto
    const cargarPresupuesto = () => {
      if (!form.value.presupuestoId) {
        form.value.codigoPresupuesto = "";
        form.value.importeOrigen = null;
        return;
      }

      const presupuesto = presupuestos.value.find(p => p.id === form.value.presupuestoId);
      if (presupuesto) {
        form.value.importe = Number(presupuesto.total ?? 0);
        form.value.descripcion = `Presupuesto ${presupuesto.codigo}`;
        form.value.codigoPresupuesto = presupuesto.codigo;
        form.value.importeOrigen = 'presupuesto';
      }
    };

    // Watchers
    watch(
      () => form.value.servicioId,
      (nuevoValor, viejoValor) => {
        if (nuevoValor && nuevoValor !== viejoValor) {
          obtenerTipoServicioYImporte(nuevoValor);
          form.value.plazas = 0;
        }
        if (!nuevoValor) {
          plazasDisponibles.value = null;
          cantidadOcupada.value = 0;
          form.value.plazas = 0;
        }
      }
    );

    watch(
      () => form.value.presupuestoId,
      (nuevoValor, viejoValor) => {
        if (nuevoValor !== viejoValor) {
          cargarPresupuesto();
        }
      }
    );

    // Carga inicial
    onMounted(async () => {
      try {
        const [
          tiposServicio, 
          caja, 
          tiposLavado, 
          servicios, 
          listaClientes, 
          listaPresupuestos
        ] = await Promise.all([
          tipoServicioService.getAllTipoServicio(),
          cajaService.getCajaAbierta(),
          lavadoService.getTipoLavado(),
          _servicioService.getAllServicios(),
          clienteService.getClientes(),
          presupuestoService.getAllPresupuestos()
        ]);

        tiposDeServicio.value = tiposServicio;
        cajaAbierta.value = caja;
        tiposLavados.value = tiposLavado;
        tiposVehiculos.value = servicios;
        clientes.value = listaClientes;
        presupuestos.value = listaPresupuestos;

        // Modo edición
        if (route.query.id) {
          const lavadoData = await lavadoService.getLavadoById(route.query.id);
          form.value = { ...form.value, ...lavadoData };
          
          if (form.value.presupuestoId) {
            form.value.importeOrigen = 'presupuesto';
            cargarPresupuesto();
          } else if (form.value.servicioId) {
            form.value.importeOrigen = 'servicio';
          }

          if (form.value.servicioId) {
            await obtenerTipoServicioYImporte(form.value.servicioId);
          }
        }

        if (route.query.isAdmin === "true") {
          isAdmin.value = true;
        }
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      }
    });

    // Enviar
    const submitForm = async () => {
      try {
        // Obtenemos los montos correctos para la caja y los pendientes
        const importe = Number(form.value.importe ?? 0);
        const importeAbonado = Number(form.value.importeAbonado ?? 0);
        const importePendiente = importe - importeAbonado;

        let montoCaja = 0;
        let montoOtrosPagos = 0;

        // La cantidad que ingresa al sistema de caja es siempre el importe abonado
        if (form.value.metodoPago === 'efectivo') {
          montoCaja = importeAbonado;
        } else {
          montoOtrosPagos = importeAbonado;
        }

        const payloadLavado = {
          ...form.value,
          importe: importe,
          importeAbonado: importeAbonado,
          importePendiente: importePendiente > 0 ? importePendiente : 0,
          montoCaja: montoCaja, // Monto para efectivo
          montoOtrosPagos: montoOtrosPagos, // Monto para otros métodos
          fecha: form.value.fecha ? new Date(form.value.fecha).toISOString() : new Date().toISOString(),
          cajaId: cajaAbierta.value?.id || form.value.cajaId,
        };
        
        // limpiar campos que no van al POST
        delete payloadLavado.tipoServicioNombre;
        delete payloadLavado.codigoPresupuesto;
        delete payloadLavado.importeOrigen;
        
        // Guardar venta/lavado
        await lavadoService.addLavado(payloadLavado);

        // --- Actualización de stock (manteniendo TU lógica) ---
        const plazasVendidas = Number(form.value.plazas ?? 0);

        if (form.value.servicioId && plazasVendidas > 0) {
          const servicioActual = await _servicioService.getById(form.value.servicioId);

          // En tu backend, maxCantidad = disponibles
          const disponibles = Number(servicioActual.maxCantidad ?? 0);
          const ocupadas = Number(servicioActual.cantidadOcupada ?? 0);

          if (plazasVendidas > disponibles) {
            alert(`No hay suficientes plazas para la venta (disponibles: ${disponibles}).`);
            return;
          }

          const payloadServicio = {
            ...servicioActual,
            maxCantidad: disponibles - plazasVendidas,
            cantidadOcupada: ocupadas + plazasVendidas,
          };

          await _servicioService.editServicio(form.value.servicioId, payloadServicio);

          plazasDisponibles.value = payloadServicio.maxCantidad;
          cantidadOcupada.value  = payloadServicio.cantidadOcupada;
        }

        router.push(isAdmin.value ? "/ventas" : "/ListLavadosCaja");

      } catch (error) {
        console.error("Error al guardar:", error?.response?.data || error?.message || error);
        alert("Error al guardar: " + (error?.response?.data?.message || error?.message || 'Desconocido'));
      }
    };

    return {
      isNegativeImport,
      form,
      tiposVehiculos,
      tiposLavados,
      submitForm,
      cajaAbierta,
      isAdmin,
      clientes,
      tiposDeServicio,
      presupuestos,
      cargarPresupuesto,
      plazasDisponibles,
    };
  },
};
</script>